import { FunctionComponent } from 'react';
import Section from '../../components/Section';
import ServicePresentationSection from './ServicePresentationSection';

export const ServicesSection: FunctionComponent = () => {
  return (
    <Section
      title="NAŠE STORITVE"
      tagline="Geodetske storitve za 
      vaše nepremičnine"
      description="Opišite nam vaš izziv, naša ekipa geodetov pa vam bo predlagala ustrezen nabor geodetskih storitev."
    >
      <ServicePresentationSection />
    </Section>
  );
};

export default ServicesSection;
